<div class="modal-window__header">
  <div class="modal-window__title">{{ "toolnotes.notes" | translate }}</div>
  <a (click)="modalService.close()">
    <i class="c-icon c-icon--close-dark"></i>
  </a>
</div>
<form
  #f="ngForm"
  id="modal-form"
  (ngSubmit)="updateNotes(notes.value)"
  class="o-grid--medium u-mt--medium">
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <textarea
      #notes="ngModel"
      name="notes"
      [ngModel]="data.notes"
      class="c-input c-input--alpha c-notes-area"
      >{{ data.notes }}</textarea
    >
  </div>
  <div class="o-grid__item col-offset-6 col-3 u-mt--medium u-tablet">
    <button
      type="button"
      class="button--sm button-secondary button-block"
      (click)="modalService.close()">
      {{ "button.cancel" | translate }}
    </button>
  </div>
  <div class="o-grid__item col-12 col-md-3 u-mt--medium">
    <button
      type="submit"
      class="button--sm button-primary button-block"
      [disabled]="f.invalid || isLoading">
      <app-loading-icon *ngIf="isLoading"></app-loading-icon>
      <span *ngIf="!isLoading">{{ "button.save" | translate }}</span>
    </button>
  </div>
</form>
